import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { formsActions } from '../forms-actions';
import { exhaustMap, filter, map, mergeMap } from 'rxjs';
import { CollectionFormService } from '../../../../features/bizzmine/form/services/collection-form.service';
import { CollectionLockApiService } from '../../../../api/bizzmine/collection-lock/collection-lock-api.service';
import { concatLatestFrom } from '@ngrx/operators';
import { selectForm } from '../forms-selectors';
import { Store } from '@ngrx/store';

/**
 * Effects for form locks
 */
@Injectable()
export class FormsLockEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store);
  public lockDeleted$ = createEffect(() => this.actions$.pipe(
    ofType(formsActions.lockDeleted),
    concatLatestFrom(props =>
      this.store$.select(selectForm(props.formId))
    ),
    map(([{ formId, form }, storeForm]) => ({
        type: formsActions.updateForm.type,
        update: {
          id: formId,
          changes: CollectionFormService.toStoreCollectionForm(CollectionFormService.deleteLock(structuredClone(form)), formId, storeForm!.status)
        }
      })
    )
  ));
  public selfLockDeleted$ = createEffect(() => this.actions$.pipe(
    ofType(formsActions.selfLockDeleted),
    concatLatestFrom(props =>
      this.store$.select(selectForm(props.formId))
    ),
    map(([{ formId, form, close }, storeForm]) => {
        return close ?
          ({
            type: formsActions.formClosed.type,
            formId: formId
          }) : ({
            type: formsActions.updateForm.type,
            update: {
              id: formId,
              changes: CollectionFormService.toStoreCollectionForm(CollectionFormService.deleteLock(structuredClone(form)), formId, storeForm!.status)
            }
          });
      }
    )
  ));
  public closeFormOnMissingLockID$ = createEffect(() => this.actions$.pipe(
    ofType(formsActions.deleteSelfLock),
    filter(({ formId, form, close }) => form?.LocksID == 0 && close),
    map(({ formId, form, close }) => ({
      type: formsActions.formClosed.type,
      formId: formId
    }))
  ));
  private collectionLockApiService = inject(CollectionLockApiService);
  public deleteLock$ = createEffect(() => this.actions$.pipe(
    ofType(formsActions.deleteLock),
    exhaustMap(({ formId, form }) => this.collectionLockApiService.deleteLock(form.CollectionsID, form.LocksID)
      .pipe(
        map(response => ({
          type: formsActions.lockDeleted.type,
          formId: formId,
          form: form
        }))
      )
    )
  ));
  public deleteExceededLock$ = createEffect(() => this.actions$.pipe(
    ofType(formsActions.deleteExceededLock),
    exhaustMap(({
                  formId,
                  form
                }) => this.collectionLockApiService.deleteLockTimeExceeded(form.CollectionsID, form.LocksID)
      .pipe(
        map(response => ({
          type: formsActions.lockDeleted.type,
          formId: formId,
          form: form
        }))
      )
    )
  ));
  public deleteSelfLock$ = createEffect(() => this.actions$.pipe(
    ofType(formsActions.deleteSelfLock),
    filter(({ formId, form, close }) => form?.LocksID > 0),
    mergeMap(({ formId, form, close }) => this.collectionLockApiService.deleteSelfLock(form.LocksID)
      .pipe(
        map(response => ({
          type: formsActions.selfLockDeleted.type,
          formId: formId,
          form: form,
          close: close
        }))
      ), 3
    )
  ));
}